import React, { useState } from "react"
import { Modal, Input, Checkbox, Button, Flex } from "antd"
import { useTranslation } from "react-i18next"
import styles from "../roleModals.module.css"
import { Icon } from "ui/Icon"

const AddRoleModal = ({ open, onCancel, onSave }) => {
  const { t } = useTranslation()
  const [roleName, setRoleName] = useState("")
  const [canBeAssignedToListings, setCanBeAssignedToListings] = useState(true)
  const [isLoading, setIsLoading] = useState(false)

  const handleCancel = () => {
    setRoleName("")
    setCanBeAssignedToListings(true)
    onCancel()
  }

  const handleSave = async () => {
    if (roleName.trim()) {
      const payload = {
        role: {
          name: roleName,
          role_type: canBeAssignedToListings ? "experience" : "administrative"
        }
      }

      setIsLoading(true)
      try {
        await onSave(payload)
        handleCancel()
      } catch (error) {
        console.log(error)
      } finally {
        setIsLoading(false)
      }
    }
  }

  return (
    <Modal
      open={open}
      onCancel={handleCancel}
      footer={null}
      width={800}
      className={styles.roleModal}
      closeIcon={
        <span className={styles.closeIcon}>
          <Icon type="feather" name="X" />
        </span>
      }
    >
      <div className={styles.modalHeader}>
        <h2 className={styles.modalTitle}>{t("staff.role_modal.add_title")}</h2>
      </div>

      <div className={styles.modalBody}>
        <div className={styles.formGroup}>
          <label className={styles.label}>
            {t("staff.role_modal.role_name")}
            <span className={styles.required}>*</span>
          </label>
          <Input
            placeholder={t("staff.role_modal.role_name_placeholder")}
            value={roleName}
            onChange={(e) => setRoleName(e.target.value)}
            className={styles.input}
            size="large"
          />
        </div>
        <Checkbox
          checked={canBeAssignedToListings}
          onChange={(e) => setCanBeAssignedToListings(e.target.checked)}
          className={styles.checkbox}
        >
          {t("staff.role_modal.can_be_assigned")}
        </Checkbox>
      </div>
      <Flex gap={12} justify="flex-end" className={styles.modalFooter}>
        <Button size="large" onClick={handleCancel} disabled={isLoading}>
          {t("staff.role_modal.cancel")}
        </Button>
        <Button type="primary" size="large" onClick={handleSave} disabled={!roleName.trim() || isLoading} loading={isLoading}>
          {t("staff.role_modal.save")}
        </Button>
      </Flex>
    </Modal>
  )
}

export default AddRoleModal
